// extracted by mini-css-extract-plugin
export default {"columns2-copy-button":"labelManagement_columns2-copy-button__k6x8u","btn":"labelManagement_btn__l8xat"};